import { render, staticRenderFns } from "./right_panel.vue?vue&type=template&id=0948a185&"
import script from "./right_panel.vue?vue&type=script&lang=js&"
export * from "./right_panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0948a185')) {
      api.createRecord('0948a185', component.options)
    } else {
      api.reload('0948a185', component.options)
    }
    module.hot.accept("./right_panel.vue?vue&type=template&id=0948a185&", function () {
      api.rerender('0948a185', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/mailboxer/right_panel.vue"
export default component.exports